export enum PriceType {
  EndsAndSides = 'ends-and-sides',
  FlatFee = 'flat-fee',
  FlatFeeEndsAndSides = 'flat-fee-ends-and-sides',
  Standard = 'standard',
}
